// src/components/Profile.js
import React, { useEffect, useState } from "react";
import userManager from "../auth/UserManager";
import "./Profile.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link } from "react-router-dom";
import classes from "./DefaultPage/DefaultPage.module.css";
import { IoClose } from "react-icons/io5";
import Button from "react-bootstrap/esm/Button";
const Profile = () => {
  const [user, setUser] = useState(null);
  const [close, setClose] = useState(false);

  function handleBurgerClick() {
    setClose((prev) => !prev);
  }

  useEffect(() => {
    userManager.getUser().then((user) => {
      if (user) {
        setUser(user.profile);
      }
    });
  }, []);

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className={classes.menu}>
        <Link to="#">
          <GiHamburgerMenu
            className={classes.burgerIcon}
            onClick={handleBurgerClick}
          />
        </Link>
        <h1 className={classes.headingText}>Mapper</h1>
      </div>
      <div>
        <h2 className="text">Profile</h2>
        <p className="text">
          <strong>Name:</strong> {user.name}
        </p>
        <p className="text">
          <strong>Email:</strong> {user.email}
        </p>
        {/* Additional profile information */}
      </div>
      <Link to="/">
        <Button variant="outline-danger">Main Menu</Button>
      </Link>
    </>
  );
};

export default Profile;
